export enum ErrorMessage {
    AccessDenied = 'Access denied',
    Unauthenticated = 'User is not authenticated'
}
